import { connect } from 'react-redux'
import Table from './Table'

import onChangeTable from './Handlers/onChangeTable'

const mapStateToProps = (state) => ({
  subOrders: state.screens.Subbies.SubOrders.subOrders,
  fetching: state.screens.Subbies.SubOrders.fetching,
  pagination: state.screens.Subbies.SubOrders.pagination,
})

const actionCreators = {
  onChangeTable,
}

export default connect(mapStateToProps, actionCreators)(Table)
